import { render, staticRenderFns } from "./mediaTab.vue?vue&type=template&id=f7072c3a"
import script from "./mediaTab.vue?vue&type=script&lang=js"
export * from "./mediaTab.vue?vue&type=script&lang=js"
import style0 from "./mediaTab.vue?vue&type=style&index=0&id=f7072c3a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports